module.exports = __webpack_public_path__ + "static/research-url-54f77ec0510b01552c832d8d434f57dc.png";